module.exports = __webpack_public_path__ + "img/icon_eliminar_coordinacion.f4160b6c.svg";